// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Tailwind's utility classes, generated based on your config file.
 */

.pointer-events-none {

    pointer-events: none
}

.pointer-events-auto {

    pointer-events: auto
}

.visible {

    visibility: visible
}

.invisible {

    visibility: hidden
}

.collapse {

    visibility: collapse
}

.static {

    position: static
}

.fixed {

    position: fixed
}

.absolute {

    position: absolute
}

.relative {

    position: relative
}

.sticky {

    position: -webkit-sticky;

    position: sticky
}

.bottom-0 {

    bottom: 0
}

.left-0 {

    left: 0
}

.right-0 {

    right: 0
}

.top-0 {

    top: 0
}

.top-8 {

    top: 0.8rem
}

.z-0 {

    z-index: 0
}

.z-10 {

    z-index: 10
}

.z-20 {

    z-index: 20
}

.z-30 {

    z-index: 30
}

.z-40 {

    z-index: 40
}

.z-50 {

    z-index: 50
}

.z-99 {

    z-index: 99
}

.z-999 {

    z-index: 999
}

.z-9999 {

    z-index: 9999
}

.order-first {

    order: -9999
}

.-m-4 {

    margin: -0.4rem
}

.m-0 {

    margin: 0
}

.m-10 {

    margin: 1.0rem
}

.m-32 {

    margin: 3.2rem
}

.m-4 {

    margin: 0.4rem
}

.m-8 {

    margin: 0.8rem
}

.-mx-12 {

    margin-left: -1.2rem;

    margin-right: -1.2rem
}

.-mx-32 {

    margin-left: -3.2rem;

    margin-right: -3.2rem
}

.-mx-8 {

    margin-left: -0.8rem;

    margin-right: -0.8rem
}

.mx-0 {

    margin-left: 0;

    margin-right: 0
}

.mx-12 {

    margin-left: 1.2rem;

    margin-right: 1.2rem
}

.mx-16 {

    margin-left: 1.6rem;

    margin-right: 1.6rem
}

.mx-24 {

    margin-left: 2.4rem;

    margin-right: 2.4rem
}

.mx-4 {

    margin-left: 0.4rem;

    margin-right: 0.4rem
}

.mx-8 {

    margin-left: 0.8rem;

    margin-right: 0.8rem
}

.mx-auto {

    margin-left: auto;

    margin-right: auto
}

.my-16 {

    margin-top: 1.6rem;

    margin-bottom: 1.6rem
}

.my-32 {

    margin-top: 3.2rem;

    margin-bottom: 3.2rem
}

.my-48 {

    margin-top: 4.8rem;

    margin-bottom: 4.8rem
}

.my-8 {

    margin-top: 0.8rem;

    margin-bottom: 0.8rem
}

.-mb-10 {

    margin-bottom: -1.0rem
}

.-mb-24 {

    margin-bottom: -2.4rem
}

.-mb-44 {

    margin-bottom: -4.4rem
}

.-ml-10 {

    margin-left: -1.0rem
}

.-mt-24 {

    margin-top: -2.4rem
}

.mb-0 {

    margin-bottom: 0
}

.mb-12 {

    margin-bottom: 1.2rem
}

.mb-16 {

    margin-bottom: 1.6rem
}

.mb-24 {

    margin-bottom: 2.4rem
}

.mb-32 {

    margin-bottom: 3.2rem
}

.mb-36 {

    margin-bottom: 3.6rem
}

.mb-4 {

    margin-bottom: 0.4rem
}

.mb-48 {

    margin-bottom: 4.8rem
}

.mb-52 {

    margin-bottom: 5.2rem
}

.mb-8 {

    margin-bottom: 0.8rem
}

.mr-14 {

    margin-right: 1.4rem
}

.mr-4 {

    margin-right: 0.4rem
}

.mr-8 {

    margin-right: 0.8rem
}

.mt-0 {

    margin-top: 0
}

.mt-12 {

    margin-top: 1.2rem
}

.mt-16 {

    margin-top: 1.6rem
}

.mt-24 {

    margin-top: 2.4rem
}

.mt-32 {

    margin-top: 3.2rem
}

.mt-48 {

    margin-top: 4.8rem
}

.mt-8 {

    margin-top: 0.8rem
}

.box-content {

    box-sizing: content-box
}

.block {

    display: block
}

.inline {

    display: inline
}

.flex {

    display: flex
}

.table {

    display: table
}

.grid {

    display: grid
}

.contents {

    display: contents
}

.hidden {

    display: none
}

.h-16 {

    height: 1.6rem
}

.h-160 {

    height: 16rem
}

.h-20 {

    height: 2rem
}

.h-24 {

    height: 2.4rem
}

.h-32 {

    height: 3.2rem
}

.h-40 {

    height: 4rem
}

.h-48 {

    height: 4.8rem
}

.h-52 {

    height: 5.2rem
}

.h-56 {

    height: 5.6rem
}

.h-72 {

    height: 7.2rem
}

.h-8 {

    height: 0.8rem
}

.h-96 {

    height: 9.6rem
}

.h-full {

    height: 100%
}

.h-screen {

    height: 100vh
}

.min-h-0 {

    min-height: 0
}

.min-h-160 {

    min-height: 16rem
}

.min-h-32 {

    min-height: 3.2rem
}

.min-h-40 {

    min-height: 4rem
}

.min-h-48 {

    min-height: 4.8rem
}

.min-h-56 {

    min-height: 5.6rem
}

.min-h-64 {

    min-height: 6.4rem
}

.min-h-92 {

    min-height: 9.2rem
}

.min-h-px {

    min-height: 1px
}

.min-h-screen {

    min-height: 100vh
}

.w-1\\/2 {

    width: 50%
}

.w-1\\/4 {

    width: 25%
}

.w-128 {

    width: 12.8rem
}

.w-16 {

    width: 1.6rem
}

.w-192 {

    width: 19.2rem
}

.w-20 {

    width: 2rem
}

.w-24 {

    width: 2.4rem
}

.w-288 {

    width: 28.8rem
}

.w-3\\/5 {

    width: 60%
}

.w-32 {

    width: 3.2rem
}

.w-320 {

    width: 32rem
}

.w-40 {

    width: 4rem
}

.w-44 {

    width: 4.4rem
}

.w-48 {

    width: 4.8rem
}

.w-52 {

    width: 5.2rem
}

.w-64 {

    width: 6.4rem
}

.w-72 {

    width: 7.2rem
}

.w-96 {

    width: 9.6rem
}

.w-\\[100\\%\\] {

    width: 100%
}

.w-auto {

    width: auto
}

.w-full {

    width: 100%
}

.min-w-0 {

    min-width: 0
}

.min-w-16 {

    min-width: 1.6rem
}

.min-w-20 {

    min-width: 2rem
}

.min-w-24 {

    min-width: 2.4rem
}

.min-w-256 {

    min-width: 25.6rem
}

.min-w-40 {

    min-width: 4rem
}

.min-w-64 {

    min-width: 6.4rem
}

.min-w-px {

    min-width: 1px
}

.max-w-288 {

    max-width: 28.8rem
}

.max-w-2xl {

    max-width: 112rem
}

.max-w-320 {

    max-width: 32rem
}

.max-w-384 {

    max-width: 38.4rem
}

.max-w-512 {

    max-width: 51.2rem
}

.max-w-full {

    max-width: 100%
}

.flex-1 {

    flex: 1 1 0%
}

.flex-auto {

    flex: 1 1 auto
}

.flex-shrink {

    flex-shrink: 1
}

.flex-shrink-0 {

    flex-shrink: 0
}

.shrink {

    flex-shrink: 1
}

.flex-grow {

    flex-grow: 1
}

.flex-grow-0 {

    flex-grow: 0
}

.transform {

    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))
}

.cursor-default {

    cursor: default
}

.cursor-pointer {

    cursor: pointer
}

.grid-cols-1 {

    grid-template-columns: repeat(1, minmax(0, 1fr))
}

.flex-row {

    flex-direction: row
}

.flex-col {

    flex-direction: column
}

.flex-wrap {

    flex-wrap: wrap
}

.items-start {

    align-items: flex-start
}

.items-end {

    align-items: flex-end
}

.items-center {

    align-items: center
}

.justify-start {

    justify-content: flex-start
}

.justify-end {

    justify-content: flex-end
}

.justify-center {

    justify-content: center
}

.justify-between {

    justify-content: space-between
}

.gap-2 {

    gap: 0.2rem
}

.gap-4 {

    gap: 0.4rem
}

.space-x-10 > :not([hidden]) ~ :not([hidden]) {

    --tw-space-x-reverse: 0;

    margin-right: calc(1.0rem * var(--tw-space-x-reverse));

    margin-left: calc(1.0rem * calc(1 - var(--tw-space-x-reverse)))
}

.space-x-4 > :not([hidden]) ~ :not([hidden]) {

    --tw-space-x-reverse: 0;

    margin-right: calc(0.4rem * var(--tw-space-x-reverse));

    margin-left: calc(0.4rem * calc(1 - var(--tw-space-x-reverse)))
}

.overflow-hidden {

    overflow: hidden
}

.overflow-x-auto {

    overflow-x: auto
}

.overflow-y-auto {

    overflow-y: auto
}

.overflow-x-hidden {

    overflow-x: hidden
}

.overscroll-contain {

    overscroll-behavior: contain
}

.truncate {

    overflow: hidden;

    text-overflow: ellipsis;

    white-space: nowrap
}

.whitespace-nowrap {

    white-space: nowrap
}

.whitespace-pre-wrap {

    white-space: pre-wrap
}

.rounded {

    border-radius: .4rem
}

.rounded-16 {

    border-radius: 1.6rem
}

.rounded-2 {

    border-radius: .2rem
}

.rounded-20 {

    border-radius: 2rem
}

.rounded-24 {

    border-radius: 2.4rem
}

.rounded-4 {

    border-radius: .4rem
}

.rounded-6 {

    border-radius: .6rem
}

.rounded-8 {

    border-radius: .8rem
}

.rounded-full {

    border-radius: 9999px
}

.rounded-lg {

    border-radius: .8rem
}

.border {

    border-width: 1px
}

.border-0 {

    border-width: 0px
}

.border-1 {

    border-width: 1px
}

.border-b-1 {

    border-bottom-width: 1px
}

.bg-\\[\\#21C9CF\\] {

    --tw-bg-opacity: 1;

    background-color: rgb(33 201 207 / var(--tw-bg-opacity, 1))
}

.bg-blue-700 {

    --tw-bg-opacity: 1;

    background-color: rgb(25 118 210 / var(--tw-bg-opacity, 1))
}

.bg-gray-50 {

    --tw-bg-opacity: 1;

    background-color: rgb(250 250 250 / var(--tw-bg-opacity, 1))
}

.bg-green-600 {

    --tw-bg-opacity: 1;

    background-color: rgb(67 160 71 / var(--tw-bg-opacity, 1))
}

.bg-orange-600 {

    --tw-bg-opacity: 1;

    background-color: rgb(251 140 0 / var(--tw-bg-opacity, 1))
}

.bg-red-600 {

    --tw-bg-opacity: 1;

    background-color: rgb(229 57 53 / var(--tw-bg-opacity, 1))
}

.bg-white {

    --tw-bg-opacity: 1;

    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1))
}

.bg-yellow-700 {

    --tw-bg-opacity: 1;

    background-color: rgb(251 192 45 / var(--tw-bg-opacity, 1))
}

.p-0 {

    padding: 0
}

.p-12 {

    padding: 1.2rem
}

.p-16 {

    padding: 1.6rem
}

.p-20 {

    padding: 2rem
}

.p-24 {

    padding: 2.4rem
}

.p-4 {

    padding: 0.4rem
}

.p-48 {

    padding: 4.8rem
}

.p-8 {

    padding: 0.8rem
}

.px-0 {

    padding-left: 0;

    padding-right: 0
}

.px-12 {

    padding-left: 1.2rem;

    padding-right: 1.2rem
}

.px-16 {

    padding-left: 1.6rem;

    padding-right: 1.6rem
}

.px-20 {

    padding-left: 2rem;

    padding-right: 2rem
}

.px-24 {

    padding-left: 2.4rem;

    padding-right: 2.4rem
}

.px-4 {

    padding-left: 0.4rem;

    padding-right: 0.4rem
}

.px-8 {

    padding-left: 0.8rem;

    padding-right: 0.8rem
}

.py-0 {

    padding-top: 0;

    padding-bottom: 0
}

.py-12 {

    padding-top: 1.2rem;

    padding-bottom: 1.2rem
}

.py-16 {

    padding-top: 1.6rem;

    padding-bottom: 1.6rem
}

.py-24 {

    padding-top: 2.4rem;

    padding-bottom: 2.4rem
}

.py-4 {

    padding-top: 0.4rem;

    padding-bottom: 0.4rem
}

.py-8 {

    padding-top: 0.8rem;

    padding-bottom: 0.8rem
}

.pb-12 {

    padding-bottom: 1.2rem
}

.pb-16 {

    padding-bottom: 1.6rem
}

.pb-24 {

    padding-bottom: 2.4rem
}

.pb-32 {

    padding-bottom: 3.2rem
}

.pb-4 {

    padding-bottom: 0.4rem
}

.pb-40 {

    padding-bottom: 4rem
}

.pb-64 {

    padding-bottom: 6.4rem
}

.pb-8 {

    padding-bottom: 0.8rem
}

.pb-96 {

    padding-bottom: 9.6rem
}

.pl-0 {

    padding-left: 0
}

.pl-24 {

    padding-left: 2.4rem
}

.pl-40 {

    padding-left: 4rem
}

.pl-56 {

    padding-left: 5.6rem
}

.pl-72 {

    padding-left: 7.2rem
}

.pl-8 {

    padding-left: 0.8rem
}

.pl-80 {

    padding-left: 8rem
}

.pr-0 {

    padding-right: 0
}

.pr-2 {

    padding-right: 0.2rem
}

.pr-28 {

    padding-right: 2.8rem
}

.pt-136 {

    padding-top: 13.6rem
}

.pt-16 {

    padding-top: 1.6rem
}

.pt-20 {

    padding-top: 2rem
}

.pt-24 {

    padding-top: 2.4rem
}

.pt-8 {

    padding-top: 0.8rem
}

.text-left {

    text-align: left
}

.text-center {

    text-align: center
}

.text-justify {

    text-align: justify
}

.text-10 {

    font-size: 1rem
}

.text-11 {

    font-size: 1.1rem
}

.text-12 {

    font-size: 1.2rem
}

.text-128 {

    font-size: 12.8rem
}

.text-13 {

    font-size: 1.3rem
}

.text-14 {

    font-size: 1.4rem
}

.text-15 {

    font-size: 1.5rem
}

.text-16 {

    font-size: 1.6rem
}

.text-18 {

    font-size: 1.8rem
}

.text-20 {

    font-size: 2rem
}

.text-24 {

    font-size: 2.4rem
}

.text-28 {

    font-size: 2.8rem
}

.text-32 {

    font-size: 3.2rem
}

.text-40 {

    font-size: 4rem
}

.text-44 {

    font-size: 4.4rem
}

.text-48 {

    font-size: 4.8rem
}

.text-72 {

    font-size: 7.2rem
}

.font-500 {

    font-weight: 500
}

.font-700 {

    font-weight: 700
}

.font-bold {

    font-weight: 700
}

.font-medium {

    font-weight: 500
}

.font-normal {

    font-weight: 400
}

.font-semibold {

    font-weight: 600
}

.uppercase {

    text-transform: uppercase
}

.capitalize {

    text-transform: capitalize
}

.italic {

    font-style: italic
}

.ordinal {

    --tw-ordinal: ordinal;

    font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction)
}

.leading-none {

    line-height: 1
}

.leading-tight {

    line-height: 1.25
}

.tracking-tight {

    letter-spacing: -0.025em
}

.tracking-tighter {

    letter-spacing: -0.05em
}

.text-green {

    --tw-text-opacity: 1;

    color: rgb(76 175 80 / var(--tw-text-opacity, 1))
}

.text-grey-700 {

    --tw-text-opacity: 1;

    color: rgb(97 97 97 / var(--tw-text-opacity, 1))
}

.text-red {

    --tw-text-opacity: 1;

    color: rgb(244 67 54 / var(--tw-text-opacity, 1))
}

.text-white {

    --tw-text-opacity: 1;

    color: rgb(255 255 255 / var(--tw-text-opacity, 1))
}

.underline {

    -webkit-text-decoration-line: underline;

            text-decoration-line: underline
}

.opacity-50 {

    opacity: 0.5
}

.opacity-60 {

    opacity: 0.6
}

.opacity-75 {

    opacity: 0.75
}

.shadow {

    --tw-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);

    --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px 0 var(--tw-shadow-color);

    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}

.shadow-0 {

    --tw-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 0px 0px 0px rgba(0, 0, 0, 0.12);

    --tw-shadow-colored: 0px 0px 0px 0px var(--tw-shadow-color), 0px 0px 0px 0px var(--tw-shadow-color), 0px 0px 0px 0px var(--tw-shadow-color);

    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}

.shadow-5 {

    --tw-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 5px 8px 0px rgba(0, 0, 0, 0.14), 0px 1px 14px 0px rgba(0, 0, 0, 0.12);

    --tw-shadow-colored: 0px 3px 5px -1px var(--tw-shadow-color), 0px 5px 8px 0px var(--tw-shadow-color), 0px 1px 14px 0px var(--tw-shadow-color);

    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}

.shadow-lg {

    --tw-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);

    --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -2px var(--tw-shadow-color);

    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}

.shadow-md {

    --tw-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);

    --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -1px var(--tw-shadow-color);

    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}

.shadow-xl {

    --tw-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);

    --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 10px 10px -5px var(--tw-shadow-color);

    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}

.outline {

    outline-style: solid
}

.drop-shadow {

    --tw-drop-shadow: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.1)) drop-shadow(0 1px 1px rgba(0, 0, 0, 0.06));

    filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)
}

.filter {

    filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)
}

.transition {

    transition-property: background-color, border-color, color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;

    transition-property: background-color, border-color, color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;

    transition-property: background-color, border-color, color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;

    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);

    transition-duration: 150ms
}

.transition-shadow {

    transition-property: box-shadow;

    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);

    transition-duration: 150ms
}

.ease-in-out {

    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1)
}

.hover\\:bg-transparent:hover {

    background-color: transparent
}

.hover\\:text-white:hover {

    --tw-text-opacity: 1;

    color: rgb(255 255 255 / var(--tw-text-opacity, 1))
}

.hover\\:shadow-md:hover {

    --tw-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);

    --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -1px var(--tw-shadow-color);

    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}

.focus\\:bg-transparent:focus {

    background-color: transparent
}

.active\\:text-white:active {

    --tw-text-opacity: 1;

    color: rgb(255 255 255 / var(--tw-text-opacity, 1))
}

@media (min-width: 600px) {

    .sm\\:mx-8 {

        margin-left: 0.8rem;

        margin-right: 0.8rem
    }

    .sm\\:ml-0 {

        margin-left: 0
    }

    .sm\\:h-64 {

        height: 6.4rem
    }

    .sm\\:w-1\\/2 {

        width: 50%
    }

    .sm\\:w-320 {

        width: 32rem
    }

    .sm\\:w-64 {

        width: 6.4rem
    }

    .sm\\:w-full {

        width: 100%
    }

    .sm\\:grid-cols-2 {

        grid-template-columns: repeat(2, minmax(0, 1fr))
    }

    .sm\\:p-32 {

        padding: 3.2rem
    }

    .sm\\:px-12 {

        padding-left: 1.2rem;

        padding-right: 1.2rem
    }

    .sm\\:pl-56 {

        padding-left: 5.6rem
    }

    .sm\\:pr-56 {

        padding-right: 5.6rem
    }

    .sm\\:text-14 {

        font-size: 1.4rem
    }

    .sm\\:text-16 {

        font-size: 1.6rem
    }

    .sm\\:text-20 {

        font-size: 2rem
    }

    .sm\\:text-24 {

        font-size: 2.4rem
    }
}

@media (min-width: 960px) {

    .md\\:mx-4 {

        margin-left: 0.4rem;

        margin-right: 0.4rem
    }

    .md\\:mb-68 {

        margin-bottom: 6.8rem
    }

    .md\\:flex {

        display: flex
    }

    .md\\:hidden {

        display: none
    }

    .md\\:h-48 {

        height: 4.8rem
    }

    .md\\:h-64 {

        height: 6.4rem
    }

    .md\\:min-h-64 {

        min-height: 6.4rem
    }

    .md\\:w-1\\/4 {

        width: 25%
    }

    .md\\:grid-cols-3 {

        grid-template-columns: repeat(3, minmax(0, 1fr))
    }

    .md\\:p-24 {

        padding: 2.4rem
    }

    .md\\:p-64 {

        padding: 6.4rem
    }

    .md\\:px-0 {

        padding-left: 0;

        padding-right: 0
    }

    .md\\:px-16 {

        padding-left: 1.6rem;

        padding-right: 1.6rem
    }

    .md\\:py-6 {

        padding-top: 0.6rem;

        padding-bottom: 0.6rem
    }

    .md\\:text-32 {

        font-size: 3.2rem
    }

    .md\\:text-64 {

        font-size: 6.4rem
    }
}

@media (min-width: 1280px) {

    .lg\\:mx-24 {

        margin-left: 2.4rem;

        margin-right: 2.4rem
    }

    .lg\\:mr-80 {

        margin-right: 8rem
    }

    .lg\\:px-20 {

        padding-left: 2rem;

        padding-right: 2rem
    }

    .lg\\:px-24 {

        padding-left: 2.4rem;

        padding-right: 2.4rem
    }

    .lg\\:pr-0 {

        padding-right: 0
    }
}

.ltr\\:left-0:where([dir="ltr"], [dir="ltr"] *) {

    left: 0
}

.ltr\\:right-0:where([dir="ltr"], [dir="ltr"] *) {

    right: 0
}

.ltr\\:right-20:where([dir="ltr"], [dir="ltr"] *) {

    right: 2rem
}

.ltr\\:right-44:where([dir="ltr"], [dir="ltr"] *) {

    right: 4.4rem
}

.ltr\\:ml-4:where([dir="ltr"], [dir="ltr"] *) {

    margin-left: 0.4rem
}

.ltr\\:ml-8:where([dir="ltr"], [dir="ltr"] *) {

    margin-left: 0.8rem
}

.ltr\\:mr-16:where([dir="ltr"], [dir="ltr"] *) {

    margin-right: 1.6rem
}

.ltr\\:mr-48:where([dir="ltr"], [dir="ltr"] *) {

    margin-right: 4.8rem
}

.ltr\\:mr-8:where([dir="ltr"], [dir="ltr"] *) {

    margin-right: 0.8rem
}

.ltr\\:pl-40:where([dir="ltr"], [dir="ltr"] *) {

    padding-left: 4rem
}

.ltr\\:pl-56:where([dir="ltr"], [dir="ltr"] *) {

    padding-left: 5.6rem
}

.ltr\\:pr-48:where([dir="ltr"], [dir="ltr"] *) {

    padding-right: 4.8rem
}

@media (min-width: 1280px) {

    .lg\\:ltr\\:mr-12:where([dir="ltr"], [dir="ltr"] *) {

        margin-right: 1.2rem
    }

    .lg\\:ltr\\:rounded-br-20:where([dir="ltr"], [dir="ltr"] *) {

        border-bottom-right-radius: 2rem
    }

    .lg\\:ltr\\:pl-0:where([dir="ltr"], [dir="ltr"] *) {

        padding-left: 0
    }

    .lg\\:ltr\\:pr-0:where([dir="ltr"], [dir="ltr"] *) {

        padding-right: 0
    }
}

.rtl\\:left-0:where([dir="rtl"], [dir="rtl"] *) {

    left: 0
}

.rtl\\:right-0:where([dir="rtl"], [dir="rtl"] *) {

    right: 0
}

.rtl\\:ml-16:where([dir="rtl"], [dir="rtl"] *) {

    margin-left: 1.6rem
}

.rtl\\:ml-48:where([dir="rtl"], [dir="rtl"] *) {

    margin-left: 4.8rem
}

.rtl\\:ml-8:where([dir="rtl"], [dir="rtl"] *) {

    margin-left: 0.8rem
}

.rtl\\:mr-4:where([dir="rtl"], [dir="rtl"] *) {

    margin-right: 0.4rem
}

.rtl\\:mr-8:where([dir="rtl"], [dir="rtl"] *) {

    margin-right: 0.8rem
}

.rtl\\:pl-48:where([dir="rtl"], [dir="rtl"] *) {

    padding-left: 4.8rem
}

.rtl\\:pr-40:where([dir="rtl"], [dir="rtl"] *) {

    padding-right: 4rem
}

.rtl\\:pr-56:where([dir="rtl"], [dir="rtl"] *) {

    padding-right: 5.6rem
}

@media (min-width: 1280px) {

    .lg\\:rtl\\:ml-12:where([dir="rtl"], [dir="rtl"] *) {

        margin-left: 1.2rem
    }

    .lg\\:rtl\\:rounded-bl-20:where([dir="rtl"], [dir="rtl"] *) {

        border-bottom-left-radius: 2rem
    }

    .lg\\:rtl\\:pl-0:where([dir="rtl"], [dir="rtl"] *) {

        padding-left: 0
    }

    .lg\\:rtl\\:pr-0:where([dir="rtl"], [dir="rtl"] *) {

        padding-right: 0
    }
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
